import { Pipe, PipeTransform } from '@angular/core';


/**------------------------------------------------------
 * Shortens by Cutting off a part and add 'trail' at the end
 * --------------
 * Usage:
 * 	value (type string) | ngTruncate : [maxLength, trail sentence]
 * Example:  (with trail word)
 * 	{{ bulletPoint1 | ngTruncate : [10, '---'] }}
 * 	truncate the bulletPoint by maxLength 10 and add '---' at the end of the sentence
 * Example:  (without trail word)
 * 	{{ bulletPoint1 | ngTruncate : [10] }}
 *  truncate the bulletPoint by maxLength 10
 */
@Pipe({
    name: 'ngTruncate',
    standalone: false
})
export class NgTruncatePipe implements PipeTransform {

	transform(value: string, args: any[]): string {

		//0 - check the limit argument
		const limit: number = (args.length > 0) ? Math.floor(args[0]) : 20;

		//1 - check the trail word
		const trail: number = (args.length > 1) ? args[1] : ' . . . ';

		//2 - return the truncated word
		return (value.length > limit)
			? value.substring(0, limit) + trail
			: value;
	}
}
